module.exports = __webpack_public_path__ + "static/media/reiki-healing.9b43e123.png";